import { z } from "zod";

// ============================================================================
// PLAYGROUND AGENTS SCHEMAS & TYPES
// ============================================================================

export const PlaygroundAgentDetailsSchema = z.object({
  name: z.string(),
  description: z.string(),
  version: z.number(),
  all_versions: z.array(z.number()),
  prompt: z.string(),
  labels: z.array(z.string()),
  tags: z.array(z.string()),
});

export type PlaygroundAgentDetails = z.infer<typeof PlaygroundAgentDetailsSchema>;

export const PlaygroundAgentsResponseSchema = z.object({
  message: z.string(),
  agents: z.record(z.string(), PlaygroundAgentDetailsSchema),
  available_models: z.array(z.string()),
});

export type PlaygroundAgentsResponse = z.infer<typeof PlaygroundAgentsResponseSchema>;

export const PlaygroundAgentInfoSchema = z.object({
  message: z.string().optional(),
  agent_name: z.string(),
  description: z.string(),
  model: z.string(),
  version: z.number(),
  all_versions: z.array(z.number()),
  prompt: z.string(),
  labels: z.array(z.string()),
  tags: z.array(z.string()),
  config: z.record(z.unknown()).optional(),
});

export type PlaygroundAgentInfo = z.infer<typeof PlaygroundAgentInfoSchema>;

export interface UpdateAgentConfigRequest {
  name: string;
  prompt: string;
  config: Record<string, unknown>;
}

export const AgentVersionInfoSchema = z.object({
  version: z.number(),
  name: z.string(),
  description: z.string(),
  model: z.string(),
  labels: z.array(z.string()),
  tags: z.array(z.string()),
});

export type AgentVersionInfo = z.infer<typeof AgentVersionInfoSchema>;

export const AgentVersionsResponseSchema = z.object({
  message: z.string(),
  agent_name: z.string(),
  versions: z.array(AgentVersionInfoSchema),
  total_versions: z.number(),
});

export type AgentVersionsResponse = z.infer<typeof AgentVersionsResponseSchema>;

export const EvalModelSchema = z.object({
  id: z.string(),
  name: z.string(),
  provider: z.string(),
  description: z.string(),
});

export const AvailableModelsResponseSchema = z.object({
  models: z.array(EvalModelSchema),
  total: z.number(),
});

export type EvalModel = z.infer<typeof EvalModelSchema>;
export type AvailableModelsResponse = z.infer<typeof AvailableModelsResponseSchema>;

// ============================================================================
// DATAMATES & KNOWLEDGE BASES SCHEMAS & TYPES
// ============================================================================

export const DataMateSchema = z
  .object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string(),
  })
  .passthrough();

export const DataMatesResponseSchema = z
  .object({
    datamates: z.array(DataMateSchema),
  })
  .passthrough();

export type DataMate = z.infer<typeof DataMateSchema>;
export type DataMatesResponse = z.infer<typeof DataMatesResponseSchema>;

export const KnowledgeBaseSchema = z
  .object({
    id: z.number(),
    name: z.string(),
  })
  .passthrough();

export type KnowledgeBase = z.infer<typeof KnowledgeBaseSchema>;
